/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <br>
    <div>
      <div class="formPosition">         
          <!-- ======================== DIALOGO REGISTRAR BOLSEIRO ===================================== -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="tipoBolseiroSelected" :disabled="true" label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="valorDesconto" :disabled="true"  label="Valor do desconto"></v-combobox>
                    </v-col>
                  </v-row>
                  <p v-if="descricaoBolseiro">*{{ descricaoBolseiro }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>





           <!-- ======================== DIALOGO REGISTRAR BOLSEIRO ===================================== -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="tipoBolseiroSelected" :disabled="true" label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="valorDesconto" :disabled="true"  label="Valor do desconto"></v-combobox>
                    </v-col>
                  </v-row>
                  <p v-if="descricaoBolseiro">*{{ descricaoBolseiro }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- ======================== SECTION -> NOVA ORGANIZAÇÃO ============================================= -->


          
          <template>
            <v-row justify="center">
              <v-dialog v-model="cardNovaOrganizacao" persistent max-width="500px">
                <v-card>
                  <v-overlay :value="overlayOrganizacao">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title>
                    <span class="headline">Nova Organização</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="nomeNovaOrganizacao" label="Forneça o nome da nova organização"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-combobox :rules="ruleRequired" v-model="idNovaOrganizacao" :items="tipoBolseiroOng" item-value="tipoBolseiroOng" item-text="descricao" return-object label="Tipo de bolseiro:" >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descricao"></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-combobox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid" @click="verificarOrganizacao()">Guardar</v-btn>
                    <v-btn @click="fecharCardNovaOrganizacao()">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ========================================== FIM NOVA ORGANIZAÇÃO ============================================ -->


          <!-- ======================== DIALOGO NOVO ESTUDANTE ===================================== -->
             <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Editar Estudante</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" md="3" v-if="isAtlantidaOrMazozo">
                      <v-text-field :rules="ruleNumber" v-model="editedItem.numeroProcesso" label="Nº Processo"></v-text-field>
                    </v-col> -->

                    <v-col cols="12" md="3">
                      <v-text-field v-if="editarDados" required :rules="ruleBI" :disabled="true" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                      <v-text-field  v-if="!editarDados" required :rules="ruleBI" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                    </v-col>
                    <v-col v-if="!editarDados" cols="12" md="2">
                      <v-switch @change="outroDoc()"></v-switch>
                    </v-col>

                    <v-col cols="12" md="3">
                      <template>
                        <v-menu ref="menubi" :rules="ruleTextRequired" v-model="menubi" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.dataemissaobi" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" max="2027-12-31" min="1950-01-01" v-model="datebi" @change="saveDatebi"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-if="false" v-model="editedItem.pkPessoa" label="chave primaria auto increemente"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedopai" label="Filho de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedamae" label=" e de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <template>
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.datanascimento" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" v-model="date" max="2022-12-31" min="1950-01-01" @change="saveDate"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.provincia" :items="provincias" item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb" return-object label="Natural de:"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.municipio" :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao" return-object label="Municipio"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox v-model="editedItem.sexo" :rules="ruleRequired" item-value="idSexo" item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                    </v-col>
                  </v-row>
                
                  <small>*Preencha correctamente os campos</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="Guardar()"> Guardar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
           <!-- =================================================================================================== -->

          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="MudarTipoEstudante()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- **************************************************************************************************** -->
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from '../../../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../../../plugins/utilitarios'
import impressaoUtilitario from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  directives: { mask },
  props:['estudante', 'provincias','municipios'],
  data: () => ({
    cardBolseiro: false,
    editarDados:false,
    mostrarOpcoesBolsa: false,
    tipoDeBolsa: '',
    descricaoBolseiro: '',
    tipoBolseiroOng: [],
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: '',
    idNovaOrganizacao: null,
    bolseiroSelected: null,
    valorDesconto: '',
    tipoBolseiroSelected: '',
    listaOngBolsas: [],
    ongBolsaSelected: null,
    showConfirmacao: false,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    classes: [],
    classesFiltered: [],
    turmasAll: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [
      value => !!value || 'campo obrigatório.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Bi', value: 'bi' },
      { text: 'Matrícula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso_descricao' },
      { text: 'Bolseiro', value: 'bolseiro'},
      { text: 'Classe', value: 'classe' },
      { text: 'Data registro', value: 'data_cadastro' },
      { text: 'Autor', value: 'autor' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    config: null,
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    overlay: false,
    numeroEstudantesCadastrado: [],
    municipiosFiltered:[],
    estudanteObjecto: null,
    dialogoConcordar: false,
    editedItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      periodo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:''
    },
    defaultItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      periodo: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:'',
    }
  }),

  computed: {

    vagasDisponiveis(){
      return parseInt((this.editedItem.turma === null || this.editedItem.turma == undefined)?0:this.editedItem.turma.capacidade) - parseInt((this.numeroEstudantesCadastrado.length)?this.numeroEstudantesCadastrado[0].qtdEstudante:0)
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    nivelEnsino() {
      return ls.get('nivel')
    },
    role() {
      return ls.get('role')
    },
    isAtlantidaOrMazozo() {
      return true//window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10') || window.location.host.includes('ispamazozo.com')
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.setFields();
  },

  methods: {
    
   async setFields(){
      this.editedItem = this.estudante
         let provinciaExistente = this.provincias.filter(p=>p.idProvincia === this.editedItem.residenteEm)
        let provinciaOBJ = (provinciaExistente.length)?provinciaExistente[0]:this.provincias[0]
        this.editedItem.provincia = provinciaOBJ
        this.municipiosFiltered = this.municipios.filter(m=>m.idProvincia === this.editedItem.residenteEm)
      
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    loadMunicipioComb(provincia) {
      this.editedItem.municipio = null
      this.municipiosFiltered = this.municipios.filter(municipio => municipio.idProvincia === provincia.idProvincia);
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

   
    openDialog() {
      this.dialog = true;
      this.editarDados = false
    },

    loadTurmaComb() {
      this.turmasFiltered = []
      this.editedItem.turma = null
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.curso.idCurso && t.idAno_Academico === this.editedItem.classeSelected.id)
      console.log(this.turmasFiltered);
    },


    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
            estudante: this.editedItem,
            nome: (this.editedItem.nome.length <= 0 || this.editedItem.nome === null) ? this.editedItem.nome : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nomedopai: (this.editedItem.nomedopai.length <= 0 || this.editedItem.nomedopai === null) ? this.editedItem.nomedopai : utilitarios.SetNameCapitalize(this.editedItem.nomedopai.trim()),
            nomedamae: (this.editedItem.nomedamae.length <= 0 || this.editedItem.nomedamae === null) ? this.editedItem.nomedamae : utilitarios.SetNameCapitalize(this.editedItem.nomedamae.trim()),
            autor: ls.get('nomeUsuario'),
             tipoEstudante: 0, // Estudante antigo, apeans não paga matricula
          }
           let result = await axios.post('estudanteEditarInformacoes', params).then((res=>res.data))
           if(result.affectedRows >=1){
              Swal.fire('Informação','Actualização feita com sucesso','success')
           }else{
            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
           }
            
           
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        } finally { 
          this.overlay = false; 
        }
      }
    },

    

   
  }
}
</script>
<style scoped>

.boldText{
   font-weight:bolder;
   font-size:15
   px;
}

.margin-card{
  margin-left:200px;
}

</style>
